import { z } from "zod";
export var EmailUndeliverableCategory;
(function (EmailUndeliverableCategory) {
    EmailUndeliverableCategory[EmailUndeliverableCategory["spamRelated"] = 0] = "spamRelated";
    EmailUndeliverableCategory[EmailUndeliverableCategory["virusRelated"] = 1] = "virusRelated";
    EmailUndeliverableCategory[EmailUndeliverableCategory["contentRelated"] = 2] = "contentRelated";
    EmailUndeliverableCategory[EmailUndeliverableCategory["protocolErrors"] = 3] = "protocolErrors";
    EmailUndeliverableCategory[EmailUndeliverableCategory["quotaIssues"] = 4] = "quotaIssues";
    EmailUndeliverableCategory[EmailUndeliverableCategory["inactiveMailbox"] = 5] = "inactiveMailbox";
    EmailUndeliverableCategory[EmailUndeliverableCategory["badMailbox"] = 6] = "badMailbox";
    EmailUndeliverableCategory[EmailUndeliverableCategory["badDomain"] = 7] = "badDomain";
    EmailUndeliverableCategory[EmailUndeliverableCategory["badConfiguration"] = 8] = "badConfiguration";
    EmailUndeliverableCategory[EmailUndeliverableCategory["noAnswerFromHost"] = 9] = "noAnswerFromHost";
    EmailUndeliverableCategory[EmailUndeliverableCategory["badConnection"] = 10] = "badConnection";
    EmailUndeliverableCategory[EmailUndeliverableCategory["routingErrors"] = 11] = "routingErrors";
    EmailUndeliverableCategory[EmailUndeliverableCategory["messageExpired"] = 12] = "messageExpired";
    EmailUndeliverableCategory[EmailUndeliverableCategory["policyRelated"] = 13] = "policyRelated";
    EmailUndeliverableCategory[EmailUndeliverableCategory["relayingIssues"] = 14] = "relayingIssues";
    EmailUndeliverableCategory[EmailUndeliverableCategory["other"] = 15] = "other";
})(EmailUndeliverableCategory || (EmailUndeliverableCategory = {}));
export const undeliverableReasonSchema = z.object({
    shortDescription: z.string(),
    longDescription: z.string(),
});
export const addressStatusSchema = z.object({
    unsubscribedAddress: z.string(), // email or sms
    unsubscribedGloballyAt: z.number().int().nonnegative().nullable(),
    unsubscribedOrganizers: z.array(z.string()), // organizer usernames
    undeliverableAt: z.number().int().nonnegative().nullable(),
    lastBounceReason: z.string().nullable(),
    quarantinedAt: z.number().int().nonnegative().nullable(),
    userBounceReason: undeliverableReasonSchema.nullable().optional(),
    isHardBounce: z.boolean().optional(),
});
